import { createUseStyles } from 'react-jss';

export const styles = createUseStyles({
  title: {
    color: '#9e9ea7',
    margin: '15px 0 2px!important',
    fontSize: 12,
    userSelect: 'none',
    fontWeight: 600,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  chartPadding: {
    '& $title': {
      marginTop: '0px!important',
    },
  },
  chartPaddingContainer: {
    position: 'relative',
  },
  chartPaddingOverlay: {
    border: '1px solid #e0e0e0',
    borderRadius: 3,
    bottom: 0,
    left: 0,
    margin: '8px 16px',
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: '3',
  },
  chartPaddingRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    zIndex: 4,
    margin: '6px 0',
  },
  chartPaddingIcon: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    cursor: 'pointer',
    '&:hover': {
      background: '#f5f5f5',
    },
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  chartType: {
    '& ul': {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      listStyle: 'none',
      gap: '1px',
      margin: 0,
    },
    '& li': {
      borderRadius: 2,
      border: '1px solid #bbb',
      background: '#f5f5f5',
      cursor: 'pointer',
      userSelect: 'none',
      '& img': {
        width: '20px',
        height: '20px',
        display: 'block',
        marginTop: '2px',
        filter: 'invert(43%) sepia(60%) saturate(6%) hue-rotate(47deg) brightness(97%) contrast(96%)',
      },
      '&:hover': {
        background: '#fff',
      },
    },
    '& .selected': {
      background: '#fff!important',
      '& img': {
        filter:
          'brightness(0) saturate(100%) invert(24%) sepia(84%) saturate(2131%) hue-rotate(206deg) brightness(93%) contrast(96%)!important',
      },
    },
  },
  chartTheme: {},
  palettes: {
    alignContent: 'flex-start',
    borderRadius: 3,
    cursor: 'pointer',
    display: 'flex',
    flexWrap: 'wrap',
    height: 30,
    marginBottom: 6,
    overflow: 'hidden',
    width: 45,
    '&.selected': {
      boxShadow: '0 0 0 3px #1464f6',
    },
  },
  palettesItem: {
    width: '15px',
    height: '15px',
  },
  palettesHolder: {
    width: '18px',
    height: '18px',
  },
  palettesIcon: {
    padding: 4,
    borderRadius: 2,
    height: 26,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  themeContainer: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
  },
  themeInner: {
    alignItems: 'center',
    background: '#fff',
    border: '1px solid #b8b8b8',
    borderRadius: 2,
    cursor: 'pointer',
    display: 'flex',
    height: '100%',
    padding: 3,
  },
  dropdown: {
    '& .ant-dropdown-menu': {
      background: '#fff',
      border: '1px solid #d6d6d6',
      borderRadius: 2,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      padding: 6,
      width: 220,
    },
    '& .ant-dropdown-menu-item': {
      padding: '0px!important',
    },
  },
  chartLegend: {
    '& ul': {
      display: 'flex',
      alignItems: 'center',
      listStyle: 'none',
      margin: 0,
      gap: 1,
    },
    '& li': {
      cursor: 'pointer',
      padding: '2px 6px',
      textAlign: 'center',
      textDecoration: 'none',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap',
      border: '1px solid #d1d1d1',
      backgroundColor: '#f5f5f5',
      borderRadius: 2,
      userSelect: 'none',
      color: '#525251',
      fontSize: 11,
      fontWeight: 600,
      '&:hover': {
        background: '#fff',
      },
      '&.selected': {
        background: '#fff',
        color: '#006ce5',
      },
    },
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    margin: '15px 0 2px',
    minHeight: 24,
    '& $title': {
      margin: '0!important',
    },
  },
  slider: {
    flex: 1,
    '& >div.ant-slider': {
      margin: '4px!important',
    },
  },
  border: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #b8b8b8',
    borderRadius: 2,
    padding: 3,
    background: '#fff',
    maxHeight: 24,
  },
  plotInput: {
    position: 'relative',
    '& input': {
      border: 'none',
      outline: 'none',
      maxWidth: 26,
      marginRight: 10,
      color: '#525251',
      fontWeight: 700,
      fontSize: 11,
    },
    '& span': {
      position: 'absolute',
      right: 3,
      userSelect: 'none',
      color: '#c2c1c1',
    },
  },
  plotPointType: {},
  plotPointTypeContainer: {
    cursor: 'pointer',
    '& img': {
      width: 20,
      height: 20,
      filter: 'invert(58%) sepia(6%) saturate(18%) hue-rotate(2deg) brightness(92%) contrast(87%)',
    },
    '& span': {
      color: '#525251',
      padding: '2.5px 5px',
      overflow: 'hidden',
      userSelect: 'none',
      whiteSpace: 'nowrap',
      fontSize: 11,
      textOverflow: 'ellipsis',
      fontWeight: 600,
    },
  },
  dropdownPlot: {
    '& .ant-dropdown-menu': {
      padding: '0!important',
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: '0 1px 1px #0000001a',
    },
    '& .ant-dropdown-menu-item': {
      padding: '0px!important',
      '& span': {
        padding: '4px 8px',
        fontSize: 11,
        display: 'block',
        whiteSpace: 'nowrap',
        color: '#525251',
        fontWeight: 600,
      },
    },
    '& .ant-dropdown-menu-item:hover': {
      '& span': {
        backgroundColor: '#006CE5',
        color: '#fff',
      },
    },
    '& .ant-dropdown-menu-title-content': {
      padding: '0!important',
    },
  },
});
